export default __webpack_public_path__ + "static/media/xandr_id.84740899.csv";